import React from 'react';
import { features } from './data';
import './Styles/Features.scss';

const Features=()=>{
    return(
        <ul className="featureslist">
        {features.map((item) =>{
            return(
                <li>
                    <div className="circle">
                        {item.icon}
                    </div>
                    <h2>{item.title}</h2>
                    <p>{item.desc}</p>
                </li>
            )
        })}
    </ul>
    )
};
export default Features ;